export default {
      id: "common__export-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__export",
      toString: function () {
        return this.url;
      }
    }